export class ReadOnlyArray<T> extends Array<T> {
  constructor(mutable: readonly T[]) {
    super(0);
    this.push(...mutable);
    Object.freeze(this);
  }

  static get [Symbol.species]() {
    return Array;
  }

  static Empty: ReadOnlyArray<never> = new ReadOnlyArray([]);
}
